import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {SchedulesModelService} from '../../../Models/Rrhh/Schedules/schedules-model.service';
import {ScheduleFilters} from '../../../../Models/Rrhh/Schedules/schedule-filters.model';
import {ScheduleStoreForm} from '../../../../Models/Rrhh/Schedules/schedule-store.model';

@Injectable({
  providedIn: 'root'
})
export class SchedulesApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: SchedulesModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener el cuadrante
   *
   */
  public getSchedules(params: ScheduleFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getCuadrante', params).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Editar cuadrante
   *
   */
  public setSchedule(params: ScheduleStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setCuadrante', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
